<template>
    <div class="bng-history-sport">
        <!-- transactions -->
        <div class="tabs is-small is-centered">
            <ul>
                <li @click="filter = 'all'; refresh()" :class="{ 'is-active': filter == 'all' }">
                    <a>{{"components.pages.history.sport.all bets" | translate}}</a>
                </li>
                <li
                    @click="filter = 'not settled'; refresh()"
                    :class="{ 'is-active': filter == 'not settled' }"
                >
                    <a>{{"components.pages.history.sport.not settled bets" | translate}}</a>
                </li>
                <li
                    @click="filter = 'settled'; refresh()"
                    :class="{ 'is-active': filter == 'settled' }"
                >
                    <a>{{"components.pages.history.sport.settled bets" | translate}}</a>
                </li>
            </ul>
        </div>

        <div
            v-if="!loading && (!bets || !bets.length)"
            class="box title is-5"
        >{{`components.pages.history.no ${filter}` | translate}}</div>

        <div v-else class="table-container">
            <table class="table is-striped is-hoverable is-fullwidth is-size-7 bng-nowrap">
                <thead>
                    <tr>
                        <th>{{ "components.pages.history.sport.bkid" | translate }}</th>
                        <th>{{ "components.pages.history.sport.time" | translate }}</th>
                        <th>{{ "components.pages.history.sport.bet type" | translate }}</th>
                        <th>{{ "components.pages.history.sport.bet" | translate }}</th>
                        <th>{{ "components.pages.history.sport.coefficient" | translate }}</th>
                        <th>{{ "components.pages.history.sport.status" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="bet of bets">
                        <tr @click="toggleBetDetails(bet);" :key="bet.bkId">
                            <td>
                                <template v-if="bet.showDetails">
                                    <span class="icon is-small">
                                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                                    </span>
                                </template>
                                <template v-else>
                                    <span class="icon is-small">
                                        <i class="fas fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </template>
                                {{bet.bkId}}
                            </td>
                            <td>
                                    {{ bet.created | localDatetime }}
                            </td>
                            <td>
                                <span v-if="bet.bkType == 'single'">{{ "bk.single" | translate }}</span>
                                <span v-if="bet.bkType == 'express'">{{ "bk.express" | translate }}</span>
                                <span
                                    v-if="bet.bkType == 'system'"
                                >{{ "bk.system" | translate }} {{bet.bkSystemN}}/{{bet.bkSelections.length}}</span>
                                <span v-if="bet.bkType == 'unknown'">{{ "bk.unknown" | translate }}</span>
                            </td>
                            <td>
                                <template v-if="bet.stakeTax === 0">
                                    {{ bet.amount | currency(bet.currency) }}
                                </template>
                                <template v-else>
                                    {{ bet.stake | currency(bet.currency) }}<span class="has-text-grey-light">+{{ bet.stakeTax | currency(bet.currency) }} (TAX {{ bet.stakeTaxFactor * 100 }}%)</span>
                                </template>
                            </td>
                            <td>@{{ bet.bkSelections.reduce((res, s) => res * s.factor, 1) | rate }}</td>
                            <td>
                                <span v-if="bet.bkIsDeleted">{{`bk.status.isDeleted` | translate}}</span>
                                <span
                                    v-else
                                    :class="{ 'has-text-success has-text-weight-bold': bet.bkStatus === 'win', 'has-text-grey': bet.bkStatus === 'loss'}"
                                >
                                    {{ `bk.status.${bet.bkStatus}` | translate }}
                                    <template
                                        v-if="bet.bkStatus === 'notSettled' && bet.possibleWinMin > 0 && bet.possibleWinMax > 0"
                                    >
                                        , {{'bk.possible win' | translate}}
                                        <template
                                            v-if="bet.possibleWinMin != bet.possibleWinMax"
                                        >{{'bk.possible win min' | translate}} {{bet.possibleWinMin | currency(bet.currency)}}, {{'bk.possible win max' | translate}} {{bet.possibleWinMax | currency(bet.currency)}}</template>
                                        <template
                                            v-else
                                        >{{bet.possibleWinMax | currency(bet.currency)}}</template>
                                    </template>
                                    <template v-if="bet.bkStatus === 'win'">
                                        <template v-if="bet.winTax === 0">
                                            {{ bet.win | currency(bet.currency) }}
                                        </template>
                                        <template v-else>
                                            {{ bet.payout | currency(bet.currency) }}<span class="has-text-grey-light">+{{ bet.winTax | currency(bet.currency) }} (TAX {{ bet.winTaxFactor * 100 }}%)</span>
                                        </template>
                                    
                                    </template>
                                </span>
                            </td>
                        </tr>
                        <tr v-if="bet.showDetails" :key="`details-${bet.bkId}`">
                            <td colspan="7">
                                <div class="box">
                                    <table class="table is-fullwidth">
                                        <tbody>
                                            <tr v-for="(selection, i) in bet.bkSelections" :key="i">
                                                <td>{{ selection.eventStartAt | localDatetime }}</td>
                                                <td>{{ selection.sport }}</td>
                                                <td>{{ selection.league }}</td>
                                                <td>
                                                    <span
                                                        class="has-text-weight-semibold"
                                                    >{{ selection.event }}</span>
                                                    <span
                                                        v-show="selection.resEventScore"
                                                        class="has-text-weight-bold has-background-warning score"
                                                    >{{ selection.resEventScore }}</span>
                                                </td>
                                                <td>
                                                    {{ translateOutcome(selection) }}
                                                </td>
                                                <td>@{{ selection.factor | rate }}</td>
                                                <td>
                                                    <span
                                                        v-if="bet.bkIsDeleted"
                                                    >{{`bk.status.isDeleted` | translate}}</span>
                                                    <span
                                                        v-else
                                                        :class="{ 'has-text-success': selection.status === 'win', 'has-text-grey': selection.status === 'loss' }"
                                                    >{{ `bk.status.${selection.status}` | translate }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <!-- load more -->
        <div class="field">
            <a
                v-if="hasLoadMore"
                :class="[{ 'is-loading': loading }, 'button', 'is-info', 'is-rounded', 'is-fullwidth']"
                @click="loadMore();"
            >{{ "components.pages.history.load more" | translate }}</a>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import bkService from '../../../../../../_common/services/bk.service';
import bkTranslatorService from '../../../../../../_common/services/bk.translator.service'
import utils from '../../../../../../_common/utils';

import Description from '../../../common/description/description.vue';

export default {
    name: 'history-sport',
    components: { Description },
    data: () => ({
        filter: 'all',
        bets: [],
        take: 20,
        skip: 0,
        loading: false,
        hasLoadMore: true
    }),
    computed: {
        balance: function() {
            return Vue.state.history.balance.get();
        },
        date: function() {
            return Vue.state.history.date.get();
        }
    },
    watch: {
        balance: async function() {
            await this.refresh();
        },
        date: async function() {
            await this.refresh();
        }
    },
    async mounted() {
        await bkTranslatorService.init(this.$i18n.locale())
        await this.refresh();
    },
    methods: {
        async loadMore() {
            this.skip += this.take;
            let loadedBets = await this.getBets();
            this.bets.push(...loadedBets);
            this.hasLoadMore = loadedBets.length >= this.take;
        },
        async refresh() {
            this.skip = 0;
            let loadedBets = await this.getBets();
            this.bets.splice(0, this.bets.length);
            this.bets.push(...loadedBets);
            this.hasLoadMore = loadedBets.length >= this.take;
        },
        async getBets() {
            this.loading = true;
            let isSettled = null;
            if (this.filter === 'not settled') {
                isSettled = false;
            } else if (this.filter === 'settled') {
                isSettled = true;
            }

            const result = await bkService.getBkBets(this.balance.id, this.date, this.take, this.skip, isSettled);
            this.loading = false;

            return result;
        },
        toggleBetDetails(bet) {
            this.$set(bet, 'showDetails', !bet.showDetails);
        },
        translateOutcome(selection) {

            if (selection.sportId === '36') {
                return this.$t(
                    `bk.lottery.${selection.class}-${selection.type}`,
                    { 
                        n: selection.ballsMain, 
                        value: selection.classValue 
                    })
            }

            if (selection.classNum === 0){
                const classStr = Vue.i18n.translate(`bk.oddClass.${selection.class}`)
                const typeStr = this.$t(`bk.oddType.${selection.type}`)
                const valueStr = selection.classValue
                return `${classStr} | ${typeStr}${valueStr ? ` | ${valueStr}` : ''}`
            }

            return bkTranslatorService.getOutcomeFullName({
                c: selection.classNum,
                t: selection.typeNum,
                sn: selection.sequenceNum,
                v: selection.classValue,
            })
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/history/sport.vue